export default "__VITE_ASSET__DAnEH9Cf__"